var React = require('react');

function Animations (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M28.5,54 C42.61,54 57,38.20 57,24.02 C57,9.84 38.83,0 24.72,0 C10.60,0 0,11.84 0,26.02 C0,40.20 14.38,54 28.5,54 Z","id":"Oval","fill":"#C5FCF6","key":0}),React.createElement("g",{"id":"activity","transform":"translate(18.000000, 18.000000)","stroke":"#009991","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1},React.createElement("polyline",{"id":"Path","points":"20 9 16 9 13 18 7 0 4 9 0 9"}))]);
}

Animations.defaultProps = {"width":"57px","height":"54px","viewBox":"0 0 57 54","version":"1.1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"};

module.exports = Animations;

Animations.default = Animations;
